import { useFilters } from '@/platform/hooks/useFilters';
import {
    Container,
    Segment,
    SegmentContent,
    SegmentHeader,
    TabNav,
    TabNavItem,
} from '@/platform/ui';
import { usePage } from '@inertiajs/react';
import QuestionnaireForm from '../Questionnaires/components/QuestionnaireForm';
import Navigation from './components/Navigation';

export const navItems = [
    {
        value: 2,
        label: 'SROI 18-56',
    },
    {
        value: 3,
        label: 'SROI 56+',
    },
];

const QuestionnaireSettingsView = () => {
    const { auth } = usePage().props;
    const { filters, updateFilters } = useFilters(['questionnaire']);

    return (
        <Container fluid>
            <Navigation />

            <Segment>
                <SegmentHeader
                    header='SROI vragenlijst instellingen'
                    subheader='Gebruik deze sectie om sroi vragen te definiëren die in vragenlijsten zullen verschijnen.'
                />
                <SegmentContent>
                    <TabNav label='Categorie'>
                        {navItems.map(navItem => (
                            <TabNavItem
                                key={navItem.value}
                                active={filters.type == navItem.value}
                                onClick={() =>
                                    updateFilters('type', navItem.value)
                                }
                            >
                                {navItem.label}
                            </TabNavItem>
                        ))}
                    </TabNav>
                </SegmentContent>
            </Segment>

            <QuestionnaireForm
                submitUrl={`/customers/${auth?.user?.selected_customer_id}/services/sroi/settings/questionnaires`}
            />
        </Container>
    );
};

export default QuestionnaireSettingsView;
